export default __webpack_public_path__ + "static/media/broken-lamp.7baf24cd.png";